import { ApplicationResponseModel } from "./application-response.model";

export class LineOfBusinessResponseModel {
  constructor(
    public code: string,
    public application: ApplicationResponseModel
  ) { }
}